var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loading"},[_c('div',{staticClass:"lottie-loader"},[_c('lottie-animation',{attrs:{"path":"lottie/dots.json"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }